import React from 'react';
import { Box, Typography } from '@mui/material';
import { navLinkTopBarSx } from '../../theme/designTokens';
import { useTranslation } from '../../content/useTranslation';
import BurgerButton, { MENU_TOGGLE_LINE_HEIGHT } from './BurgerButton';

interface MenuToggleProps {
  open: boolean;
  onClick: () => void;
  color: string;
}

const MenuToggle: React.FC<MenuToggleProps> = ({ open, onClick, color }) => {
  const { t } = useTranslation();
  return (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: '12px',
      height: MENU_TOGGLE_LINE_HEIGHT,
    }}
  >
    <BurgerButton open={open} onClick={onClick} color={color} />
    <Typography
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        ...navLinkTopBarSx,
        color,
        background: 'none',
        border: 'none',
        m: 0,
        p: 0,
        cursor: 'pointer',
        fontFamily: 'inherit',
        lineHeight: MENU_TOGGLE_LINE_HEIGHT,
        height: MENU_TOGGLE_LINE_HEIGHT,
        display: 'inline-flex',
        alignItems: 'center',
        transition: 'color 0.35s ease',
      }}
    >
      {t.menuLabel}
    </Typography>
  </Box>
  );
};

export default MenuToggle;
